import React, { useEffect, useState } from "react";
import "./LegalEntities.css";
import { Col, Row, Table, Dropdown } from "antd";
import { BsPencil } from "react-icons/bs";
import { MdOutlineBlock } from "react-icons/md";
import { EyeFilled, UploadOutlined } from "@ant-design/icons";
import acmec22 from "../../assets/acmec22.png";
import { useSelector } from "react-redux";
import LegalEntitesForm from "./LegalEntitiesForm";
import Pencil from "../../assets/icons/pencil.svg";
import {
  BASE_URL,
  CHECKAUTH_ENDPOINT,
  UpdateLegalEntities,
} from "../../utils/constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import ImageView from "./ImageView";
function LegalEntities() {
  const {
    companyName = "",
    logo = "",
    firstName = "",
    lastName = "",
    email = "",
    phoneNumber = "",
    aadharNumber = "",
  } = useSelector((state) => state.signUp.signUpDetails);
  const [formVisible, setFormVisible] = useState(false);
  const [imgformVisible, setImgformVisible] = useState(false);
  const [indexData, setIndexData] = useState();
  const [showImg, setShowImg] = useState();
  const [totalStaff, setTotalStaff] = useState();
  const [panFileUrl, setPanFileUrl] = useState(null);
  const [gstinFileUrl, setGstinFileUrl] = useState(null);
  const [tanFileUrl, setTanFileUrl] = useState(null);
  const [pfFileUrl, setPfFileUrl] = useState(null);
  const [esiFileUrl, setEsiFileUrl] = useState(null);
  const [initialValues, setInitialValues] = useState(null);
  const userInfo = useSelector((state) => state.signUp.signUpDetails);
  const handlePanFile = (e) => {
    const fileInput = e.target;
    const file = fileInput.files[0];

    fileInput.value = null;

    if (file) {
      if (file.type.startsWith("image/")) {
        const maxSizeInBytes = 2 * 1024 * 1024;
        if (file.size <= maxSizeInBytes) {
          const extension = file.name.split(".").pop().toLowerCase();

          const allowedExtensions = ["png", "jpg", "jpeg"];

          if (allowedExtensions.includes(extension)) {
            editLegalEntities(file, "panFileUrl");
          } else {
            toast.error(
              "Only PNG, JPG, and JPEG formats are allowed for the Pan image.",
              {
                position: toast.POSITION.TOP_RIGHT,
              }
            );
          }
        } else {
          toast.error("Image size should be less than or equal to 2 MB.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } else {
        toast.error("Select image only.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  };
  const handleGstinFile = (e) => {
    const fileInput = e.target;
    const file = fileInput.files[0];

    fileInput.value = null;

    if (file) {
      if (file.type.startsWith("image/")) {
        const maxSizeInBytes = 2 * 1024 * 1024;
        if (file.size <= maxSizeInBytes) {
          // Get the file extension
          const extension = file.name.split(".").pop().toLowerCase();

          // Allowed file extensions
          const allowedExtensions = ["png", "jpg", "jpeg"];

          // Check if the file extension is allowed
          if (allowedExtensions.includes(extension)) {
            editLegalEntities(file, "gstinFileUrl");
          } else {
            toast.error(
              "Only PNG, JPG, and JPEG formats are allowed for the Gstine image.",
              {
                position: toast.POSITION.TOP_RIGHT,
              }
            );
          }
        } else {
          toast.error("Image size should be less than or equal to 2 MB.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } else {
        toast.error("Select image only.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  };
  const handleTanFile = (e) => {
    const fileInput = e.target;
    const file = fileInput.files[0];

    // Clear the input field value
    fileInput.value = null;

    if (file) {
      if (file.type.startsWith("image/")) {
        const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB in bytes
        if (file.size <= maxSizeInBytes) {
          // Get the file extension
          const extension = file.name.split(".").pop().toLowerCase();

          // Allowed file extensions
          const allowedExtensions = ["png", "jpg", "jpeg"];

          // Check if the file extension is allowed
          if (allowedExtensions.includes(extension)) {
            editLegalEntities(file, "tanFileUrl");
          } else {
            toast.error(
              "Only PNG, JPG, and JPEG formats are allowed for the Tan image.",
              {
                position: toast.POSITION.TOP_RIGHT,
              }
            );
          }
        } else {
          toast.error("Image size should be less than or equal to 2 MB.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } else {
        toast.error("Select image only.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  };
  const handlePfFile = (e) => {
    const fileInput = e.target;
    const file = fileInput.files[0];

    // Clear the input field value
    fileInput.value = null;

    if (file) {
      if (file.type.startsWith("image/")) {
        const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB in bytes
        if (file.size <= maxSizeInBytes) {
          // Get the file extension
          const extension = file.name.split(".").pop().toLowerCase();

          // Allowed file extensions
          const allowedExtensions = ["png", "jpg", "jpeg"];

          // Check if the file extension is allowed
          if (allowedExtensions.includes(extension)) {
            editLegalEntities(file, "pfFileUrl");
          } else {
            toast.error(
              "Only PNG, JPG, and JPEG formats are allowed for the Pf image.",
              {
                position: toast.POSITION.TOP_RIGHT,
              }
            );
          }
        } else {
          toast.error("Image size should be less than or equal to 2 MB.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } else {
        toast.error("Select image only.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  };
  const handleEsiFile = (e) => {
    const fileInput = e.target;
    const file = fileInput.files[0];

    // Clear the input field value
    fileInput.value = null;

    if (file) {
      if (file.type.startsWith("image/")) {
        const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB in bytes
        if (file.size <= maxSizeInBytes) {
          // Get the file extension
          const extension = file.name.split(".").pop().toLowerCase();

          // Allowed file extensions
          const allowedExtensions = ["png", "jpg", "jpeg"];

          // Check if the file extension is allowed
          if (allowedExtensions.includes(extension)) {
            editLegalEntities(file, "esiFileUrl");
          } else {
            toast.error(
              "Only PNG, JPG, and JPEG formats are allowed for the Esi image.",
              {
                position: toast.POSITION.TOP_RIGHT,
              }
            );
          }
        } else {
          toast.error("Image size should be less than or equal to 2 MB.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } else {
        toast.error("Select image only.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  };
  const editLegalEntities = (file, name) => {
    const fetchData = async () => {
      const token = localStorage.getItem("authToken");
      const formData = new FormData();
      formData.append(name, file);

      const response = await fetch(`${BASE_URL}/${UpdateLegalEntities}`, {
        method: "POST",
        headers: {
          Authorization: `${token}`,
        },
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        fetchLegalEntityData();
      } else {
        const data = await response.json();
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
        console.log("errdata", data);
      }
    };
    fetchData();
  };
  const showForm = (item) => {
    setFormVisible(true);
  };
  const hideForm = (item) => {
    setFormVisible(false);
    fetchLegalEntityData();
  };
  const showImgForm = (item) => {
    setShowImg(item);
    setImgformVisible(true);
  };
  const hideImgForm = (item) => {
    setImgformVisible(false);
  };

  useEffect(() => {
    fetchLegalEntityData();
  }, []);

  const fetchLegalEntityData = async () => {
    const fetchData = async () => {
      const token = localStorage.getItem("authToken");

      const response = await fetch(`${BASE_URL}/${CHECKAUTH_ENDPOINT}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(),
      });

      if (response.ok) {
        const data = await response.json();
        setTotalStaff(data?.data?.overAllStaffCount);
        setIndexData(data?.data?.legalEntity);
      } else {
        const data = await response.json();
        console.log("indexerr", data);
      }
    };
    await fetchData();
  };

  return (
    <div>
      <Row>
        <Col lg={10}>
          <div className="legal-back !mt-8 px-4 !py-4">
            <Row>
              <Col lg={3}>
                {/* <span className='legal-p'>T</span> */}
                <img
                  src={logo}
                  style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                />
              </Col>
              <Col lg={21}>
                <div className="flex">
                  <p className="text-lg font-bold">{companyName}</p>
                  <img
                    src={Pencil}
                    onClick={() => showForm()}
                    className="ml-auto cursor-pointer"
                  />
                  {/* <Dropdown menu={{ items }} placement="bottom" arrow>
                    <p className="ml-5 company">Company</p>
                  </Dropdown> */}
                </div>
                {/* <p className="acma">Acme</p>
                <p className="legal-id">ID: 4534546546</p> */}
                <p className="text-lg font-sbold text-[#1E1E1E]">
                  Total Employees: {totalStaff}
                </p>
              </Col>
              <Col lg={4} className="flex">
                {/* <MdOutlineBlock className="legal-pen1" /> */}
              </Col>
            </Row>
            <div className="legal-pan-back">
              <div className="flex justify-between">
                <p className="legal-num font-sbold">
                  PAN: {indexData?.panNumber ? indexData.panNumber : "--"}
                </p>
                <div>
                  {indexData?.panFileUrl ? (
                    <>
                      <EyeFilled
                        onClick={() => {
                          showImgForm(indexData?.panFileUrl);
                        }}
                        className="eye cursor-pointer"
                      />
                      <span className="legal-view cursor-pointer">
                        <span
                          onClick={() => {
                            showImgForm(indexData?.panFileUrl);
                          }}
                        >
                          View
                        </span>
                      </span>
                    </>
                  ) : (
                    <label className="cursor-pointer">
                      <UploadOutlined className="eye" />
                      <span className="legal-view"> upload</span>

                      <input
                        type="file"
                        className="hidden"
                        onChange={handlePanFile}
                      />
                    </label>
                  )}
                  {/* {indexData?.panFileUrl ?
                  <span className="legal-view cursor-pointer">
                     <span onClick={() => {showImgForm(indexData?.panFileUrl)}}>View</span> 
                  </span>
                     : ""} */}
                </div>
              </div>
              <div className="flex justify-between">
                <p className="legal-num font-sbold">
                  GSTIN: {indexData?.gstinNumber ? indexData.gstinNumber : "--"}
                </p>
                <div>
                  {indexData?.gstinFileUrl ? (
                    <>
                      <EyeFilled
                        onClick={() => {
                          showImgForm(indexData?.gstinFileUrl);
                        }}
                        className="eye cursor-pointer"
                      />
                      <span className="legal-view cursor-pointer">
                        <span
                          onClick={() => {
                            showImgForm(indexData?.gstinFileUrl);
                          }}
                        >
                          View
                        </span>
                      </span>
                    </>
                  ) : (
                    <label className="cursor-pointer">
                      <UploadOutlined className="eye" />
                      <span className="legal-view"> upload</span>

                      <input
                        type="file"
                        className="hidden"
                        onChange={handleGstinFile}
                      />
                    </label>
                  )}
                  {/* {indexData?.gstinFileUrl ?
                  <span className="legal-view cursor-pointer">
                     <span onClick={() => {showImgForm(indexData?.gstinFileUrl)}}>View</span> 
                  </span>
                     : ""} */}
                </div>
              </div>
              <div className="flex justify-between">
                <p className="legal-num font-sbold">
                  TAN: {indexData?.tanNumber ? indexData.tanNumber : "--"}
                </p>
                <div>
                  {indexData?.tanFileUrl ? (
                    <>
                      <EyeFilled
                        onClick={() => {
                          showImgForm(indexData?.tanFileUrl);
                        }}
                        className="eye cursor-pointer"
                      />
                      <span className="legal-view cursor-pointer">
                        <span
                          onClick={() => {
                            showImgForm(indexData?.tanFileUrl);
                          }}
                        >
                          View
                        </span>
                      </span>
                    </>
                  ) : (
                    <label className="cursor-pointer">
                      <UploadOutlined className="eye" />
                      <span className="legal-view"> upload</span>

                      <input
                        type="file"
                        className="hidden"
                        onChange={handleTanFile}
                      />
                    </label>
                  )}
                  {/* {indexData?.tanFileUrl ? 
                  <span className="legal-view cursor-pointer">
                   <span onClick={() => {showImgForm(indexData?.tanFileUrl)}}>View</span> 

                  </span>
                    : ""} */}
                </div>
              </div>
            </div>

            <div className="legal-pan-back">
              <div className="flex justify-between">
                <p className="legal-num font-sbold">
                  PF: {indexData?.pfNumber ? indexData.pfNumber : "--"}
                </p>
                <div>
                  {indexData?.pfFileUrl ? (
                    <>
                      <EyeFilled
                        onClick={() => {
                          showImgForm(indexData?.pfFileUrl);
                        }}
                        className="eye cursor-pointer"
                      />
                      <span className="legal-view cursor-pointer">
                        <span
                          onClick={() => {
                            showImgForm(indexData?.pfFileUrl);
                          }}
                        >
                          View
                        </span>
                      </span>
                    </>
                  ) : (
                    <label className="cursor-pointer">
                      <UploadOutlined className="eye" />
                      <span className="legal-view"> upload</span>
                      <input
                        type="file"
                        className="hidden"
                        onChange={handlePfFile}
                      />
                    </label>
                  )}
                  {/* {indexData?.pfFileUrl ? 
                  <span className="legal-view cursor-pointer">
                     <span onClick={() => {showImgForm(indexData?.pfFileUrl)}}>View</span> 

                  </span>
                    : ""} */}
                </div>
              </div>
              <div className="flex justify-between">
                <p className="legal-num font-sbold">
                  ESI: {indexData?.esiNumber ? indexData.esiNumber : "--"}
                </p>
                <div>
                  {indexData?.esiFileUrl ? (
                    <>
                      <EyeFilled
                        onClick={() => {
                          showImgForm(indexData?.esiFileUrl);
                        }}
                        className="eye cursor-pointer"
                      />
                      <span className="legal-view cursor-pointer">
                        <span
                          onClick={() => {
                            showImgForm(indexData?.esiFileUrl);
                          }}
                        >
                          View
                        </span>
                      </span>
                    </>
                  ) : (
                    <label className="cursor-pointer">
                      <UploadOutlined className="eye" />
                      <span className="legal-view"> upload</span>

                      <input
                        type="file"
                        className="hidden"
                        onChange={handleEsiFile}
                      />
                    </label>
                  )}
                  {/* {indexData?.esiFileUrl ? 
                  <span className="legal-view cursor-pointer">
                    
                    <span onClick={() => {showImgForm(indexData?.esiFileUrl)}}>View</span> 

                  </span>
                    : ""} */}
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <LegalEntitesForm
        open={formVisible}
        initialValues={indexData}
        onCancel={hideForm}
      />
      <ImageView
        open={imgformVisible}
        showImg={showImg}
        onCancel={hideImgForm}
      />
    </div>
  );
}

export default LegalEntities;
